import colors from './colors';

export default {
  common: {
    white: colors.white,
    cream: colors.cream,
    grey: colors.neutral[500],
  },
  primary: {
    main: colors.chiantiRed,
    mainDisabled: colors.chiantiRedDarker,
    mainOpaque: colors.cream,
  },
  secondary: {
    main: colors.green[500],
    lightMain: colors.blushBrown,
  },
  error: {
    main: colors.pink[500],
    light: colors.pink[50],
    contrastMain: colors.pink[800],
  },
  success: {
    main: colors.green[500],
    light: colors.green[50],
    contrastMain: colors.green[800],
  },
  info: {
    main: colors.blue500,
    light: colors.blue50,
    divider: colors.black,
  },
  background: {
    default: colors.cream,
    textInput: colors.neutral[50],
    divider: colors.blue300,
    lightDivider: colors.blueLight,
    separator: colors.copper,
    header: colors.cream,
    contrastShadow: colors.neutral[50],
    neutral: colors.neutral[50],
    tag: colors.blushBrown,
    tagBorder: colors.neutral[300],
    calories: colors.lightBlue,
    total: colors.lightBlue,
    progress: colors.pink[50],
    heart: colors.pink[300],
    splitItems: colors.lightBlue,
    billTotalContainer: colors.lightBlue,
    textInputTitle: colors.blue200,
    shadow: colors.neutral[500],
    discounted: colors.orangeAurora,
    lightButton: colors.neutral[100],
    container: colors.neutral[50],
    paper: colors.cream,
    imageOverlay: colors.neutral[400],
  },
  action: {
    disabled: colors.blueDisabled,
    selected: colors.blue700,
    activeOption: colors.neutral[800],
    deselected: colors.blueDeselected,
    active: colors.green[500],
    contrast: colors.neutral[200],
    inactive: colors.blue50,
  },
  text: {
    primary: colors.zizziBlue,
    secondary: colors.chiantiRed,
    tertiary: colors.neutral[500],
    selected: colors.green[500],
    contrastText: colors.white,
    logo: colors.zizziBlue,
    slider: colors.neutral[500],
    tableColumn: colors.neutral[500],
    editControls: colors.pink[500],
    header: colors.zizziBlue,
  },
  menuNavigation: {
    mainCategoryBackground: colors.cream,
    mainCategorySelectedBackground: colors.chiantiRed,
    mainCategorySelectedText: colors.white,
    subCategoryBackground: colors.cream,
    subCategoryText: colors.zizziBlue,
    subCategorySelectedBackground: colors.lightBlue,
    subCategorySelectedText: colors.zizziBlue,
  },
  icon: {
    loyalty: colors.orangeAurora,
    heart: colors.pink[500],
    loyaltyLogo: colors.cream,
  },
};
